<template>
  <div v-show="num === control" class="zoom">
    <!-- Título y subtítulo -->
    <v-row align="center">
      <v-col>
        <h4
          class="text-uppercase font-italic primary--text"
          v-html="step.title"
        ></h4>
        <div class="caption font-italic grey--text">{{ step.subtitle }}</div>
      </v-col>
    </v-row>

    <!-- contenidos -->
    <div>
      <mdd-paso-subtitulo :subtitle="t.mdd.leer" :help="step.help[0]" />

      <!-- santo -->
      <v-row v-if="showSanto">
        <v-col>
          <div
            class="font-italic font-weight-bold primary--text"
            v-text="lectio.santo"
          ></div>
          <div v-html="lectio.txtSant"></div>
          <div class="primary--text" v-html="lectio.txtOraSant"></div>
        </v-col>
      </v-row>
      <!-- lecturas -->
      <v-row>
        <!-- TODO: evaluar si evento touchend se puede cambiar por touchstart or touchchange-->
        <v-col
          id="hl-cont"
          class="pt-2"
          :class="'modo-' + modo"
          hl-container
          @click="clicContenedorHl($event)"
        >
          <div
            class="font-italic font-weight-bold primary--text"
            v-text="lectio.lbPrimera"
          ></div>
          <div
            v-lighted:[modo]="lectioHl.txtPrimera"
            hl-source="txtPrimera"
            hl-field="pr"
          ></div>
          <div
            class="font-italic font-weight-bold primary--text"
            v-text="lectio.lbSalmo"
          ></div>
          <div
            class="font-italic font-weight-bold primary--text"
            v-lighted:[modo]="lectioHl.rtaSalmo"
            hl-source="rtaSalmo"
            hl-field="rs"
          ></div>
          <div
            v-lighted:[modo]="lectioHl.txtSalmo"
            hl-source="txtSalmo"
            hl-field="sa"
          ></div>
          <div
            class="font-italic font-weight-bold primary--text"
            v-text="lectio.lbSegunda"
          ></div>
          <div
            v-lighted:[modo]="lectioHl.txtSegunda"
            hl-source="txtSegunda"
            hl-field="se"
          ></div>
          <div
            class="font-italic font-weight-bold primary--text"
            v-text="lectio.lbEvang"
          ></div>
          <div
            v-lighted:[modo]="lectioHl.txtEvang"
            hl-source="txtEvang"
            hl-field="ev"
          ></div>
        </v-col>
      </v-row>

      <!-- btn siguiente seccion -->
      <v-row align="center" class="pa-2 pr-3">
        <v-btn icon large @click.stop="showHelp = true">
          <v-icon :color="colorBtn">help</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn :color="colorBtn" @click.stop="$emit('siguiente')">
          <v-icon left>done</v-icon>{{ t.app.siguiente }}
        </v-btn>
      </v-row>
    </div>

    <!-- mensaje de ayuda -->
    <v-dialog v-model="showHelp" width="400">
      <v-card>
        <v-card-text class="pa-4">
          <p class="subtitle-2 primary--text mt-2">{{ step.title }}</p>
          <v-divider class="my-4"></v-divider>
          <p class="body-1">
            <span>{{ t.lecturas.msgTutor1 }}</span>
            <v-icon>touch_app</v-icon>
            <span>{{ t.lecturas.msgTutor2 }}</span>
          </p>
          <p class="body-1">
            <span>{{ t.lecturas.msgTutor3 }}</span>
            <v-icon>text_format</v-icon>
          </p>
          <p class="body-1 mb-0">
            <span>{{ t.lecturas.msgTutor4 }}</span>
            <v-icon class="mr-1">delete_sweep</v-icon>
            <span>{{ t.lecturas.msgTutor5 }}</span>
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showHelp = false">
            {{ t.app.cerrar }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MddPasoSubtitulo from "./MddPasoSubtitulo";

//  /<\/{0,1}\w+((\s+\w+(\s*=\s*(?:".*?"|'.*?'|[^'">\s]+))?)+\s*|\s*)\/{0,1}>/g
const rexHtmlLabels = RegExp(/<[^>]*>/g);

// directive lighted
const txtLight = {
  // https://vuejs.org/v2/guide/custom-directive.html
  bind(el, b) {
    // var modoSelect = b.arg === "select" || false; // eliminar - select

    el.__resaltar = false;

    el.innerHTML =
      b.value.txt && b.value.hl ? insertSpans(b.value) : b.value.txt;

    el.onselectstart = () => {
      // window.__canScroll = false;
      el.classList.add("si");
      el.parentNode.classList.add("resaltar");
      el.__resaltar = true;
    };

    el.ontouchend = () => {
      // window.__canScroll = true;
      // let sel = document.getSelection();
      // if (sel.anchorNode === null || sel.isCollapsed) {
      if (el.__resaltar) {
        el.classList.remove("si");
        el.parentNode.classList.remove("resaltar");
        el.__resaltar = false;
      }
    };

    el.onclick = () => {
      // window.__canScroll = true;
      // let sel = document.getSelection();
      // if (sel.anchorNode === null || sel.isCollapsed) {
      if (el.__resaltar) {
        // e.preventDefault();
        el.classList.remove("si");
        el.parentNode.classList.remove("resaltar");
        el.__resaltar = false;
      }
    };

    // el.onblur = () => {
    //   // let sel = document.getSelection();
    //   // if (sel.anchorNode === null || sel.isCollapsed) {
    //   if (el.__resaltar) {
    //     el.classList.remove("si");
    //     el.parentNode.classList.remove("resaltar");
    //     el.__resaltar = false;
    //   }
    // };
  },
  // el, binding, vnode, oldVnode
  // update(el, b, vnode, oldVnode) {
  update(el, b) {
    el.innerHTML =
      b.value.txt && b.value.hl ? insertSpans(b.value) : b.value.txt;
  }
};

// directive seleccion de texto
const selectTxt = {
  // https://vuejs.org/v2/guide/custom-directive.html
  bind(el, b) {
    el.__modoSelect = b.value === "select" || false;

    // eslint-disable-next-line no-unused-vars
    el.ontouchstart = e => {
      if (el.__modoSelect) {
        console.log("start", e);
      }
    };

    // eslint-disable-next-line no-unused-vars
    el.ontouchend = e => {
      if (el.__modoSelect) {
        console.log("end", e);
      }
    };

    el.onclick = e => {
      if (el.__modoSelect) {
        console.log("onclick:", e);
      }
    };
  },

  update(el, b) {
    el.__modoSelect = b.value === "select" || false;
  }
};

// eslint-disable-next-line no-unused-vars
function selectElementContents(el) {
  if (window.getSelection && document.createRange) {
    var sel = window.getSelection();
    var range = document.createRange();
    range.selectNodeContents(el);
    sel.removeAllRanges();
    sel.addRange(range);
    // var startPar = [the p node];
    // var endLi = [the second li node];
    // range.setStart(startPar,13);
    // range.setEnd(endLi,17);
    console.log(range);
  } else if (document.selection && document.body.createTextRange) {
    var textRange = document.body.createTextRange();
    textRange.moveToElementText(el);
    textRange.select();
  }
}

function insertSpans(data) {
  let iniTxt = data.txt.slice(0, data.hl.min);
  let midTxt = prepareMidTxt(data.txt, data.hl.hls, data.hl.max, data.field);
  let endTxt = data.txt.slice(data.hl.max);
  return iniTxt + midTxt + endTxt;
}

// function prepareMidTxt(txt, hls, max, field) {
function prepareMidTxt(txt, hls, max, field) {
  // hls array {i: ini, e: end, c: class-color}
  let txts = "";

  for (let i = 0; i < hls.length; i++) {
    const hl = hls[i];
    const endTxt = hls[i + 1] !== undefined ? hls[i + 1].i : max;
    const hlTxt = txt.slice(hl.i, hl.e);
    const overText = txt.slice(hl.e, endTxt);
    txts = txts + insertLabelSpans(hlTxt, hl.c || "", field, i) + overText;
  }
  return txts;
}

function insertLabelSpans(txt, clase, field, i) {
  let rep = '</span>$&<span class="hl' + clase + '">';
  txt = txt.replace(rexHtmlLabels, rep);
  txt = txt.replace('<span class="hl' + clase + '"></span>', "");
  let ini = '<span class="hl' + clase + '"';
  ini = ini + ' field="' + field + '"';
  ini = ini + ' idx="' + i + '">';
  return ini + txt + "</span>";
}

import userConfig from "../../mixs/mixUserConfig";

export default {
  name: "mdd-paso-lecturas",
  components: { MddPasoSubtitulo },
  mixins: [userConfig],
  props: ["hl", "lectio", "step", "num", "control", "modo"],
  directives: { lighted: txtLight, seltxt: selectTxt },
  data() {
    return {
      showHelp: false
    };
  },
  computed: {
    colorBtn() {
      return this.tieneHls ? "primary" : "warning";
    },
    t() {
      return this.$store.getters["app/trad/activa"];
    },
    tieneHls() {
      return this.hl.cant ? this.hl.cant > 0 : false;
    },
    hlVer() {
      return this.hl._ver || false;
    },
    lectioHl() {
      return {
        txtPrimera: {
          txt: this.lectio.txtPrimera,
          hl: this.hl.pr ? this.hl.pr : false,
          field: "pr"
        },
        rtaSalmo: {
          txt: this.lectio.rtaSalmo,
          hl: this.hl.rs ? this.hl.rs : false,
          field: "rs"
        },
        txtSalmo: {
          txt: this.lectio.txtSalmo,
          hl: this.hl.sa ? this.hl.sa : false,
          field: "sa"
        },
        txtSegunda: {
          txt: this.lectio.txtSegunda,
          hl: this.hl.se ? this.hl.se : false,
          field: "se"
        },
        txtEvang: {
          txt: this.lectio.txtEvang,
          hl: this.hl.ev ? this.hl.ev : false,
          field: "ev"
        }
      };
    },
    showSanto() {
      return this.userConfig && this.userConfig.orm
        ? this.userConfig.orm.san
        : false;
    }
  },
  methods: {
    clicContenedorHl(e) {
      // modo eliminar
      if (this.modo === "eliminar") {
        if (e.path[0].attributes.field !== undefined) {
          this.$emit("eliminar", {
            index: e.path[0].attributes.idx.value,
            field: e.path[0].attributes.field.value
          });
        } else {
          // desactiva el modo eliminar
          this.$emit("eliminar", false);
        }
      }
    }
  }
};
</script>

<style>
.rta,
.pregReflex {
  color: #00bcd4;
  font-style: italic;
  font-weight: bold;
}

.hl {
  background-color: #c9e9ff;
}

.modo-eliminar .hl {
  background-color: #ffcccc;
}

#hl-cont.resaltar div:not(.si) {
  opacity: 0.5;
}
</style>
